import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage, useIntl} from 'react-intl'
import {Box, Flex, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {remCalc} from '../../../../../overrides/app/theme/_utils'

const PaperlessStickyMenu = ({product, sectionButtons}) => {
    const stickyMenuStyles = useMultiStyleConfig('StickyMenu', {variant: 'paperless'})
    const intl = useIntl()

    const scrollToSection = (ref) => {
        if (ref?.current)
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            })
    }

    return (
        <Box
            {...stickyMenuStyles.stickyBar}
            sx={{
                '::-webkit-scrollbar': {display: 'none'},
                msOverflowStyle: 'none',
                scrollbarWidth: 'none',
            }}
            data-testid="paperless-sticky-menu"
        >
            <Flex layerStyle="full-width" {...stickyMenuStyles.stickyBarContent}>
                <Box width={remCalc(250)} display={{base: 'none', md: 'block'}}>
                    <Text
                        {...stickyMenuStyles.productText}
                        sx={{
                            display: {base: '-webkit-box', lg: 'block'},
                            WebkitLineClamp: {base: 2, lg: 'unset'},
                            WebkitBoxOrient: {base: 'vertical', lg: 'unset'},
                            overflow: {base: 'hidden', lg: 'visible'},
                            textOverflow: {base: 'ellipsis', lg: 'unset'},
                        }}
                    >
                        {product?.name}
                    </Text>
                </Box>
                <Box {...stickyMenuStyles.sectionButtonGroup}>
                    {sectionButtons
                        .filter((section) => section.visible)
                        .map((section) => (
                            // Qui renderizzi il bottone/link solo se la sezione è visibile
                            <Text
                                key={section.id}
                                onClick={() => scrollToSection(section.ref)}
                                cursor={'pointer'}
                                whiteSpace={'nowrap'}
                                _hover={{textDecoration: 'underline'}}
                                role="button"
                                aria-label={intl.formatMessage(section)}
                            >
                                <FormattedMessage {...section} />
                            </Text>
                        ))}
                </Box>
                <Box />
            </Flex>
        </Box>
    )
}

PaperlessStickyMenu.propTypes = {
    product: PropTypes.object,
    sectionButtons: PropTypes.arrayOf(
        PropTypes.shape({
            ref: PropTypes.object,
            id: PropTypes.string,
            defaultMessage: PropTypes.string,
        }),
    ).isRequired,
    manualsRef: PropTypes.object,
}
export default PaperlessStickyMenu
